// This will be part of the dash after a user has logged in 
import React from 'react'
import { Outlet } from 'react-router-dom'
import DashHeader from './DashHeader'
import DashFooter from './DashFooter'

{/* Placing the dashheader above the other means that the dashheader will be above every page on the protected part of our site, So this is the layout for the protected site, we wont see it in the public page, we will only see it once we make to the dahsboard page which is the protected part */}
const DashLayout = () => {
  return (
    <>
      <DashHeader></DashHeader>
        <div className='dash-container'>
            <Outlet></Outlet>
        </div>
      <DashFooter></DashFooter>
    </> 
  )
}

export default DashLayout